class ExtensionValidator {
    constructor(extensionsInUse, currentExtension) {
        this.extensionsInUse = extensionsInUse;
        this.currentExtension = Number(currentExtension);
    }

    validate(extension) {
        let invalidMessage = ""
        let valid = true;

        const extensionsInUse = this.extensionsInUse.filter(ext => ext !== 0 && ext !== this.currentExtension)

        if (checkExtensionInUse(extension, extensionsInUse) === true) {
            invalidMessage = "The extension you have entered is already in use, try a different extension"
            valid = false;
        }

        return { valid, invalidMessage }
    }
}

export class ZoneExtensionValidator extends ExtensionValidator {
    constructor(extensionsInUse, currentExtension) {
        super(extensionsInUse, currentExtension);
        this.validate = this.validate.bind(this);
    }

    validate(extension) {
        let { valid, invalidMessage } = ExtensionValidator.prototype.validate.call(this, extension);

        if (checkZoneExtensionValidity(extension) === false) {
            invalidMessage = "The extension, if entered, must be four digits and begin with a 6"
            valid = false;
        }

        if (extension === "6") {
            invalidMessage = "";
            valid = true;
        }

        return { valid, invalidMessage }
    }
}

export class AlertExtensionValidator extends ExtensionValidator {
    constructor(extensionsInUse, currentExtension) {
        super(extensionsInUse, currentExtension);
        this.validate = this.validate.bind(this);
    }

    validate(extension) {
        let { valid, invalidMessage } = ExtensionValidator.prototype.validate.call(this, extension);

        if (checkAlertExtensionValidity(extension) === false) {
            invalidMessage = "The extension, if entered, must be four digits and begin with a 9"
            valid = false;
        }

        if (extension === "9") {
            invalidMessage = "";
            valid = true;
        }

        return { valid, invalidMessage }
    }
}

export class DeviceExtensionValidator extends ExtensionValidator {
    constructor(extensionsInUse, currentExtension) {
        super(extensionsInUse, currentExtension);
        this.validate = this.validate.bind(this);
    }

    validate(extension) {
        let { valid, invalidMessage } = ExtensionValidator.prototype.validate.call(this, extension);

        if (checkDeviceExtensionValidity(extension) === false) {
            invalidMessage = "The extension must be four digits and cannot begin with a 6 or 9"
            valid = false;
        }

        if (extension.trim() === "") {
            invalidMessage = "The extension is required"
            valid = false;
        }

        return { valid, invalidMessage }
    }
}

function checkExtensionValidity(ext, regex) {
    if (ext.toString().trim() === "") return true;
    return regex.test(ext.toString().trim());
}

function checkZoneExtensionValidity(ext) {
    return checkExtensionValidity(ext, /^6\d{3}$/);
}

function checkAlertExtensionValidity(ext) {
    return checkExtensionValidity(ext, /^9\d{3}$/);
}

function checkDeviceExtensionValidity(ext) {
    //Allow devices to have extensions 9000-9010, 9050-9060, and 9700-9710
    if(checkExtensionValidity(ext, /^(?:(?:900|905|970)[0-9]|9010|9060|9710)$/)) {
        return true;
    }
    return checkExtensionValidity(ext, /^[^69\D]\d{3}$/);
}

function checkExtensionInUse(ext, used) {
    return used.includes(Number(ext));
}